module.exports = "<router-outlet></router-outlet>\n<biermi-modal></biermi-modal>"